import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { version } from '../../../environments/version';

export interface AppConfig {
  apiUrl:       string;
  apiProneUrl:  string;
  qrUrl:        string;
  //* Opcional: base de las rutas V2 del kiosk (`{base}v2/{companyId}/station/...`).
  //* Si no se define se usa apiUrl. apiProneUrl queda para las rutas legacy (`station/v2/...`).
  apiStationV2Url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PreloadConfigService {
  private readonly http = inject(HttpClient);

  private readonly _config = signal<AppConfig | null>(null);
  public readonly config = this._config.asReadonly();

  async load(): Promise<void> {
    await this.refreshConfig();
  }

  async refreshConfig(forceBypassCache = false): Promise<boolean> {
    const url = this.buildConfigUrl(forceBypassCache);
    const data = await firstValueFrom(this.http.get<AppConfig>(url));

    const previousConfig = this._config();
    const hasChanges = !previousConfig || !this.sameConfig(previousConfig, data);

    if (hasChanges) {
      this._config.set(data);
    }

    return hasChanges;
  }

  private buildConfigUrl(forceBypassCache: boolean): string {
    const params = new URLSearchParams({ v: version });

    if (forceBypassCache) {
      params.set('t', Date.now().toString());
    }

    return `assets/config.json?${params.toString()}`;
  }

  private sameConfig(left: AppConfig, right: AppConfig): boolean {
    return (
      left.apiUrl === right.apiUrl
      && left.apiProneUrl === right.apiProneUrl
      && left.qrUrl === right.qrUrl
      && left.apiStationV2Url === right.apiStationV2Url
    );
  }

  /**
   * Acceso seguro y tipado al apiUrl
   */
  // readonly apiUrl = signal<string>('', { equal: Object.is });

  /**
   * Inicializa señales derivadas después de cargar config
   */
  initializeDerivedSignals(): void {
    const initialConfig = this._config();
    if (!initialConfig) return console.error('No se encontro file: JSONconfigService');

    // this.apiUrl.set(initialConfig.apiUrl);
  }
}
